import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';

const apiUrl = GlobalConstants.apiURL

@Injectable({
  providedIn: 'root'
})
export class HairRemovalService {

  constructor(private http: HttpClient, private sharedapi: SharedService) { }

  getHairRemovalLeadDetail(lead_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-hair-removal-lead-details/'+lead_id,{headers:webheader})
  }

  addHairRemovalDetail(leadId,HairRemovalData)
  {
      let lead_id = leadId;
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-hair-removal-detail/'+lead_id,HairRemovalData,{headers:webheader})
  }

  getHairRemovalBookingDetail(lead_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-hair-removal-booking-details/'+lead_id,{headers:webheader})
  }

  uploadHairRemovalFile(lead_id,formData)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'upload-hair-removal-docs/'+lead_id,formData,{headers:webheader})
  }

  deleteHairRemovalFile(fileId)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.delete(apiUrl+'delete-hair-removal-file/'+fileId,{headers:webheader})
  }

  receivedAmountDeleted(hair_removal_Payment_Id) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.delete(apiUrl+'delete-hair-removal-payment/'+hair_removal_Payment_Id,{headers:webheader})
  }

  getAllHairRemovalData(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-all-hair-removal/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  getFullHairRemovalHistory(hair_removal_booking_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-full-hair-removal-history/'+hair_removal_booking_id,{headers:webheader})
  }

  getHairRemovalDetails(data)
    {
        let lead_id = data.lead_id;
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-hair-removal-details/'+lead_id,{headers:webheader})
    }

   viewHairRemovalDetails(hair_removal_booking_id)
   {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'view-hair-removal-details/'+hair_removal_booking_id,{headers:webheader})
   }

   selectedSessionDeleted(sessionDetailId) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.delete(apiUrl+'delete-hair-removal-session/'+sessionDetailId,{headers:webheader})
  }

}
